import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18.6 0H1.4C.6 0 0 .6 0 1.4v17.2c0 .8.6 1.4 1.4 1.4h17.2c.8 0 1.4-.6 1.4-1.4V1.4c0-.8-.6-1.4-1.4-1.4ZM6 17.1H3V7.6h3v9.5ZM4.6 6.3a1.7 1.7 0 1 1 0-3.4 1.7 1.7 0 0 1 0 3.4ZM17.2 17h-3v-4.6c0-1.1 0-2.5-1.5-2.5-1.6 0-1.8 1.2-1.8 2.4V17h-3V7.6h2.8v1.3c.5-.7 1.5-1.5 2.9-1.5 3 0 3.6 2 3.6 4.5v5.2Z" }, null, -1)
  ])))
}
export default { render: render }